/* KUAKEMLA – theme.js */

document.addEventListener('DOMContentLoaded', function () {

  // ── Mobile menu ──
  const hamburger = document.querySelector('.kk-hamburger');
  const mobileMenu = document.querySelector('.kk-nav__mobile');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      mobileMenu.classList.toggle('open');
    });
  }

  // ── Tabs (productos destacados) ──
  document.querySelectorAll('.kk-tab').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.kk-tab').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const target = btn.getAttribute('data-tab');
      if (target) {
        document.querySelectorAll('.kk-tab-panel').forEach(panel => {
          panel.style.display = (panel.id === target) ? 'block' : 'none';
        });
      }
    });
  });

  // ── Scroll reveal ──
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.kk-reveal').forEach(el => observer.observe(el));

  // ── Cart count update ──
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const el = document.querySelector('.kk-nav__cart-count');
        if (el) el.textContent = cart.item_count;
      });
  }
  updateCartCount();

  // ── Add to cart (product page) ──
  const addToCartForm = document.querySelector('.kk-atc-form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(this);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(r => r.json())
        .then(() => {
          updateCartCount();
          const btn = this.querySelector('.kk-add-to-cart');
          btn.textContent = '✓ Agregado';
          btn.style.background = '#25D366';
          setTimeout(() => {
            btn.textContent = 'Agregar al Carrito';
            btn.style.background = '';
          }, 2000);
        })
        .catch(() => {
          window.location = '/cart';
        });
    });
  }

});
